<section class="mojo-admin-page panel data-table full-page-widget full-page-scrollable">
  <div class="panel-body">
    <div class="widget-content">
      <div class="table-search" style="margin:0 0 5px 0;">
        <input #gb
               (input)="dt.filterGlobal($event.target.value, 'contains')"
               placeholder="Search..."
               pInputText
               type="text">
        <p-button id="edit-filter-button"
                  alt="Edit Filter"
                  (onClick)="showFilterDialog()"
                  class="btn btn-default"
                  type="button"
                  title="Advanced Filter">
          <span class="fa-stack">
            <i class="fa fa-filter fa-stack-1x fa-lg"></i>
            <i *ngIf="hasCustomFilter" class="fa fa-check fa-stack-1x custom-filter"></i>
          </span>
        </p-button>
        <p-button id="download-button"
                  *ngIf="displayExportButton"
                  alt="Export CSV"
                  (onClick)="export()"
                  class="btn btn-default"
                  type="button"
                  icon="fa-fw fa fa-download"></p-button>
      </div>
      <div #container class="data-table table-container">
          <p-table #dt [value]="filteredUsers"
                  selectionMode="multiple"
                  [(selection)]="selectedUsers"
                  responsiveLayout="scroll"
                  [rows]="10"
                  [columns]="getPrimeColumns()"
                  dataKey="id"
                  (onRowUnselect)="onRowUnSelect()"
                  (onRowSelect)="onRowSelect()">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                  {{col.header}}
                  <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <th style="width: 50px">
                  <input type="checkbox"
                         [disabled]="filteredUsers?.length === 0"
                         [checked]="selectAllState === 'all'"
                         (change)="toggleSelectAll($event)"
                         [indeterminate]="selectAllState === 'indeterminate'"
                         [ngClass]="{
                           'checkbox-selected': selectAllState === 'all',
                           'checkbox-indeterminate': selectAllState === 'indeterminate',
                           'checkbox-unselected': selectAllState === 'none'
                         }">
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-userProfile let-rowData let-columns="columns" let-rowIndex="rowIndex">
              <tr [pSelectableRow]="rowData">
                <td *ngFor="let col of columns" class="ui-resizable-column">
                  <ng-container *ngIf="col.type === 1">{{rowData[col.field]}}</ng-container>
                  <ng-container *ngIf="col.type === 3">{{rowData[col.field]  | date:'dd-MMM-yyyy'}}</ng-container>
                </td>
                <td style="width: 50px" class="table-selected-column">
                  <input type="checkbox" [checked]="isRowSelected(rowData)" (change)="toggleRowSelection(rowData)"
                         [ngClass]="{
                           'checkbox-selected': isRowSelected(rowData),
                           'checkbox-unselected': !isRowSelected(rowData)
                         }">
                </td>
                 </tr>
            </ng-template>
          </p-table>
        <mojo-table-paginator [table]="dt"></mojo-table-paginator>
      </div>
    </div>
  </div>

  <p-footer>
    <div class="table-button-section ui-helper-clearfix">
      <span><button type="button" pButton (click)="showDialogToAdd()" label="+ Add"></button></span>
      <span><button type="button" [disabled]="selectedUsers.length != 1" pButton (click)="showDialogToEdit()" label="Edit"></button></span>
      <span><button type="button" [disabled]="selectedUsers.length == 0" pButton (click)="inviteUsers()" label="Invite"></button></span>
      <span><button type="button" [disabled]="selectedUsers.length == 0" pButton (click)="disableUsers()" label="Deactivate"></button></span>
    </div>
  </p-footer>

  <mojo-user-editor [dialogTitle]="'User Editor'" [limitedByOptions]="limitedByOptions" [clients]="mappedClientsForDropdown" [clientParents]="mappedClientParentsForDropdown"(onSaveComplete)="loadUsers()" ></mojo-user-editor>

  <mojo-filter-editor-dialog
    (onSaveFilter)="filterEdited($event)"
    [queryConfig]="queryConfig">
  </mojo-filter-editor-dialog>

</section>
